import { DocsVerificationStatusEnum, ManualFieldNamesEnum } from '@models/enums';

export const isVerificationNotCompleted = (status: DocsVerificationStatusEnum) =>
    status === DocsVerificationStatusEnum.PENDING || status === DocsVerificationStatusEnum.INITIAL;

export const getManualFieldName = (name: string) => {
    let label = name;
    let placeholder = '';

    switch (name) {
        case ManualFieldNamesEnum.FULL_NAME:
            label = 'common.fullName';
            placeholder = 'docVerificationWidget.personalDataForm.fullNamePlaceholder';
            break;
        case ManualFieldNamesEnum.EMAIL:
            label = 'common.email';
            break;
        case ManualFieldNamesEnum.PHONE:
            label = 'common.phone';
            break;
        case ManualFieldNamesEnum.ADDRESS:
            label = 'common.address';
            break;
        case ManualFieldNamesEnum.ADDRESS_LINE1:
            label = 'common.address_line1';
            break;
        case ManualFieldNamesEnum.ADDRESS_LINE2:
            label = 'common.address_line2';
            break;
        case ManualFieldNamesEnum.SSN:
            label = 'common.ssn';
            break;
        case ManualFieldNamesEnum.ZIP:
            label = 'common.zip';
            break;
        case ManualFieldNamesEnum.STATE:
            label = 'common.state';
            break;
        case ManualFieldNamesEnum.CITY:
            label = 'common.city';
            break;
        case ManualFieldNamesEnum.DOB:
            label = 'common.dateOfBirth';
            break;
        case ManualFieldNamesEnum.GENDER:
            label = 'common.gender';
            break;
        case ManualFieldNamesEnum.CITIZENSHIP:
            label = 'common.citizenship';
            break;
        case ManualFieldNamesEnum.COUNTRY:
            label = 'common.country';
            break;
        default:
            label = name;
    }

    return {
        label,
        placeholder,
    };
};
